import { Heading, Column, Button } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

interface IDepartmentDisplay {
  departmentName: string;
  changeToEditMode: () => void;
}

export default function DepartmentNameDisplayMode({
  departmentName,
  changeToEditMode,
}: IDepartmentDisplay): JSX.Element {
  return (
    <>
      <Column desktop={6} gutter={12}>
        <Heading variant="h4">{departmentName}</Heading>
      </Column>
      {departmentName !== 'Unassigned' && (
        <Column desktop={2} gutter={12}>
          <Button
            variant="secondary"
            buttonSize="small"
            block
            onClick={changeToEditMode}
          >
            Edit name
          </Button>
        </Column>
      )}
    </>
  );
}
